import { SmlsInputText } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/RedoRegisterTangie/context/MemberDataContext';
import React, { useState } from 'react';

export function AddressNumberInput() {
  const { handler, setFormEdit } = useMemberData();
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation('redo-register-v2');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    setFormEdit();
    setValue(inputValue);
    handler({ streetNumber: inputValue });
  };

  return (
    <SmlsInputText
      textLabel={t('labels.addressNumber')}
      value={value}
      onChange={handleChange}
      data-testid="first-access-address-number-input"
    />
  );
}
